'use strict';

var React = require('react');

var SvgTransactionFeeRupeeMajor = function SvgTransactionFeeRupeeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.25 3a2.25 2.25 0 1 0 1 4.266v3.984a2.75 2.75 0 0 0 2.75 2.75h.25a.75.75 0 0 0 0-1.5h-.25c-.69 0-1.25-.56-1.25-1.25v-5.25h2.878a2.251 2.251 0 1 0 0-1.5h-3.256a2.25 2.25 0 0 0-2.122-1.5Zm-.75 2.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Zm7.5 0a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.143 15.611a.75.75 0 0 1-.786 1.278l-2.814-1.732c-.769-.473-.433-1.657.469-1.657.463 0 .852-.32.96-.75h-1.222a.75.75 0 0 1 0-1.5h1.25v-.75h-1.25a.75.75 0 0 1 0-1.5h3.5a.75.75 0 0 1 0 1.5h-.75v.75h.75a.75.75 0 0 1 0 1.5h-.761a2.487 2.487 0 0 1-1.06 1.807l1.714 1.054Z"
  }));
};
SvgTransactionFeeRupeeMajor.displayName = "TransactionFeeRupeeMajor";

exports.SvgTransactionFeeRupeeMajor = SvgTransactionFeeRupeeMajor;
